<dt-modal-content size="normal" (closeClick)="dialogRef.close()" [flexContent]="true">
  <ng-template i18n #title>Teile „{{ project.name }}“</ng-template>
  <ng-template #content>
    <p i18n
      >Mit dem untenstehenden Link kannst Du das Projekt <span class="bold">„{{ project.name }}“</span> mit anderen Personen teilen. Diese
      können die aktuelle Version des Projekts anschauen und eigene Änderungen vornehmen. Dein Projekt bleibt von diesen Änderungen
      unberührt und kann auch weiterhin nur von Dir verändert werden.</p
    >
    <mat-slide-toggle
      labelPosition="after"
      [checked]="project.shareToken"
      [disabled]="loading"
      (toggleChange)="toggleLink()"
      [dtOverlayProgress]="loading"
      [dtOverlayProgressColor]="'accent'"
      data-cy="share-project-toggle"
    >
      @if (project.shareToken) {
        <ng-container i18n>Linkfreigabe ist aktiv</ng-container>
      } @else {
        <ng-container i18n>Linkfreigabe ist inaktiv</ng-container>
      }
    </mat-slide-toggle>
    @if (project.shareToken) {
      <mat-form-field (click)="linkInput.select()" color="accent">
        <mat-label>Link</mat-label>
        <input #linkInput [value]="link" matInput readonly data-cy="share-project-link" />
        <mat-icon matSuffix matRipple [cdkCopyToClipboard]="linkInput.value">content_copy</mat-icon>
      </mat-form-field>
    }
  </ng-template>
</dt-modal-content>
